import React from 'react';
import cc from 'classcat';
import * as luxon from 'luxon';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".react-calendar_1-1-10_co-calendar,\n.react-calendar_1-1-10_co-calendar__weekdays,\n.react-calendar_1-1-10_co-calendar__weekday,\n.react-calendar_1-1-10_co-calendar__days,\n.react-calendar_1-1-10_co-calendar__day,\n.react-calendar_1-1-10_co-calendar__day-inner {\n  box-sizing: border-box;\n}\n\n.react-calendar_1-1-10_co-calendar {\n  padding: 0;\n  margin: 0;\n  font-family: var(--font-family);\n}\n\n.react-calendar_1-1-10_co-calendar__weekday,\n.react-calendar_1-1-10_co-calendar__day {\n  margin: var(--base-spacing) 0;\n  font-family: var(--font-family);\n  font-size: var(--font-size-medium, 14px);\n}\n\n.react-calendar_1-1-10_co-calendar__weekdays,\n.react-calendar_1-1-10_co-calendar__days {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n}\n\n.react-calendar_1-1-10_co-calendar__weekday {\n  text-align: center;\n  font-weight: var(--font-weight-medium, 500);\n}\n\n.react-calendar_1-1-10_co-calendar__day {\n  text-align: center;\n}\n\n.react-calendar_1-1-10_co-calendar__day-inner {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: var(--day-btn-radius, 4px);\n  box-shadow: var(--day-box-shadow);\n  color: var(--day-font-color, var(--basic-800, #202830));\n  background-color: var(--day-btn-bg-color);\n  text-align: center;\n}\n\n.react-calendar_1-1-10_co-calendar__day.react-calendar_1-1-10_co-calendar__day--highlighted {\n  --day-box-shadow: inset 0 0 0 2px var(--primary-600, #6f767d);\n}\n.react-calendar_1-1-10_co-calendar__day.react-calendar_1-1-10_co-calendar__day--selected:not(.react-calendar_1-1-10_co-calendar__day--range) {\n  --day-btn-bg-color: var(--primary-600, #6f767d);\n  --day-font-color: var(--basic-000, #ffffff);\n}\n.react-calendar_1-1-10_co-calendar__day.react-calendar_1-1-10_co-calendar__day--range {\n  --day-btn-bg-hover: var(--basic-400, #d7dbde);\n  background-color: var(--primary-300, #e8eaeb);\n}\n.react-calendar_1-1-10_co-calendar__day.react-calendar_1-1-10_co-calendar__day--range-first {\n  --day-btn-bg-color: var(--primary-600, #6f767d);\n  --day-btn-radius: 4px 0 0 4px;\n  --day-font-color: var(--basic-000, #ffffff);\n  --day-btn-bg-hover: var(--primary-600, #6f767d);\n  background: linear-gradient(to right, transparent 50%, var(--primary-300, #e8eaeb) 50%);\n}\n.react-calendar_1-1-10_co-calendar__day.react-calendar_1-1-10_co-calendar__day--range-last {\n  --day-btn-bg-color: var(--primary-600, #6f767d);\n  --day-btn-radius: 0 4px 4px 0;\n  --day-font-color: var(--basic-000, #ffffff);\n  --day-btn-bg-hover: var(--primary-600, #6f767d);\n  background: linear-gradient(to left, transparent 50%, var(--primary-300, #e8eaeb) 50%);\n}\n.react-calendar_1-1-10_co-calendar__day[data-co-disabled] {\n  opacity: var(--opacity-light, 0.16);\n  pointer-events: none;\n}\n\n.react-calendar_1-1-10_co-calendar__day-inner.react-calendar_1-1-10_co-calendar__day-inner--selectable {\n  padding: 0;\n  margin: 0;\n  border: 0;\n  touch-action: manipulation;\n  outline: none;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n.react-calendar_1-1-10_co-calendar__day-inner.react-calendar_1-1-10_co-calendar__day-inner--selectable[data-co-hover], .react-calendar_1-1-10_co-calendar__day-inner.react-calendar_1-1-10_co-calendar__day-inner--selectable:hover, .react-calendar_1-1-10_co-calendar__day-inner.react-calendar_1-1-10_co-calendar__day-inner--selectable[data-co-focus], .react-calendar_1-1-10_co-calendar__day-inner.react-calendar_1-1-10_co-calendar__day-inner--selectable:focus {\n  background-color: var(--day-btn-bg-hover, var(--day-btn-bg-color, var(--basic-300, #e8eaeb)));\n}";
var styles = {
  "co-calendar": "react-calendar_1-1-10_co-calendar",
  "co-calendar__weekdays": "react-calendar_1-1-10_co-calendar__weekdays",
  "co-calendar__weekday": "react-calendar_1-1-10_co-calendar__weekday",
  "co-calendar__days": "react-calendar_1-1-10_co-calendar__days",
  "co-calendar__day": "react-calendar_1-1-10_co-calendar__day",
  "co-calendar__day-inner": "react-calendar_1-1-10_co-calendar__day-inner",
  "co-calendar__day--highlighted": "react-calendar_1-1-10_co-calendar__day--highlighted",
  "co-calendar__day--selected": "react-calendar_1-1-10_co-calendar__day--selected",
  "co-calendar__day--range": "react-calendar_1-1-10_co-calendar__day--range",
  "co-calendar__day--range-first": "react-calendar_1-1-10_co-calendar__day--range-first",
  "co-calendar__day--range-last": "react-calendar_1-1-10_co-calendar__day--range-last",
  "co-calendar__day-inner--selectable": "react-calendar_1-1-10_co-calendar__day-inner--selectable"
};
styleInject(css);

const PREVIOUS_MONTH_DAY = 0;
const NEXT_MONTH_DAY = 32;
luxon.Settings.defaultLocale = "en";

const getLuxonDate = (year, month, day) => {
  return luxon.DateTime.fromObject({
    year,
    month,
    day
  });
};

const validateDates = (year, month) => {
  const date = getLuxonDate(year, month);

  if (!date.isValid) {
    throw new Error("Invalid value: the specified value for month or year is not valid.");
  }
};
const getWeekDays = weekStart => {
  const weekDaysShort = luxon.Info.weekdays("short");
  const weekStartKey = weekDaysShort.findIndex(weekDay => weekDay.toUpperCase() === weekStart);
  const weekDaysUppercase = weekDaysShort.map(weekday => weekday.toUpperCase());
  return [...weekDaysUppercase.slice(weekStartKey), ...weekDaysUppercase.slice(0, weekStartKey)];
};
const getEmptyDays = (weekStart, year, month) => {
  const dayOne = getLuxonDate(year, month, 1);
  const firstDayInMonthUpper = dayOne.weekdayShort.toUpperCase();
  const nrEmptyDays = getWeekDays(weekStart).lastIndexOf(firstDayInMonthUpper);
  return new Array(nrEmptyDays).fill(0);
};
const getDaysInMonth = (year, month) => {
  const nrDaysInMonth = getLuxonDate(year, month).daysInMonth;
  return new Array(nrDaysInMonth).fill(0);
};
const containsDay = (daysArray, day) => {
  // Verify if single selection
  if (daysArray.map(date => Number(date)).includes(day)) return "single"; // Verify if range selection

  const datesRanges = daysArray.filter(item => typeof item === "object" && ("start" in item || "end" in item));
  if (datesRanges.length === 0) return;
  const rangeMatch = datesRanges.filter(range => {
    const {
      start = PREVIOUS_MONTH_DAY,
      end = NEXT_MONTH_DAY
    } = range;
    return day >= Number(start) && day <= Number(end);
  })[0];
  if (!rangeMatch) return;
  const {
    start = PREVIOUS_MONTH_DAY,
    end = NEXT_MONTH_DAY
  } = rangeMatch;

  if (day === Number(start)) {
    return "first";
  } else if (day === Number(end)) {
    return "last";
  } else {
    return "between";
  }
};

const WeekDays = ({
  days,
  weekStart
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles["co-calendar__weekdays"]
  }, getWeekDays(weekStart).map(weekday => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles["co-calendar__weekday"],
      key: weekday
    }, days[weekday]);
  }));
};

const onDayEvent = (date, callback) => {
  if (!callback) return;
  return () => {
    callback(date);
  };
};

const DayInner = ({
  date,
  disabled,
  onClick,
  onMouseEnter
}) => {
  const {
    day
  } = date;
  const isSelectable = (onClick || onMouseEnter) && !disabled;
  const classStyles = cc([styles["co-calendar__day-inner"], {
    [styles["co-calendar__day-inner--selectable"]]: isSelectable
  }]);
  return isSelectable ? /*#__PURE__*/React.createElement("button", {
    className: classStyles,
    onClick: onDayEvent(date, onClick),
    onMouseEnter: onDayEvent(date, onMouseEnter)
  }, day) : /*#__PURE__*/React.createElement("span", {
    className: classStyles
  }, day);
};

const Day = ({
  date,
  disabled,
  highlighted,
  onClick,
  onMouseEnter,
  selection
}) => {
  const classStyles = cc([styles["co-calendar__day"], {
    [styles["co-calendar__day--highlighted"]]: highlighted,
    [styles["co-calendar__day--selected"]]: selection,
    [styles["co-calendar__day--range"]]: selection && selection !== "single",
    [styles["co-calendar__day--range-first"]]: selection === "first",
    [styles["co-calendar__day--range-last"]]: selection === "last"
  }]);
  return /*#__PURE__*/React.createElement("div", {
    className: classStyles,
    "aria-disabled": disabled || undefined,
    "data-co-disabled": disabled || undefined
  }, /*#__PURE__*/React.createElement(DayInner, {
    date: date,
    onClick: onClick,
    onMouseEnter: onMouseEnter
  }));
};

const Days = ({
  month,
  year,
  disabledDays,
  weekStart,
  highlightedDays,
  onDayClick,
  onDayMouseEnter,
  selectedDays
}) => {
  const emptyDays = getEmptyDays(weekStart, year, month).map((_, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    });
  });
  const monthsDays = getDaysInMonth(year, month).map((_, index) => {
    const day = index + 1;
    const currentDate = {
      year,
      month,
      day
    };
    const isDisabled = !!containsDay(disabledDays, day);
    const isHighlighted = !!containsDay(highlightedDays, day);
    const selection = containsDay(selectedDays, day);
    return /*#__PURE__*/React.createElement(Day, {
      key: index,
      date: currentDate,
      disabled: isDisabled,
      highlighted: isHighlighted,
      onClick: onDayClick,
      onMouseEnter: onDayMouseEnter,
      selection: selection
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles["co-calendar__days"]
  }, emptyDays, monthsDays);
};

const Calendar = ({
  className = "",
  forwardedRef,
  month,
  weekdays,
  year,
  disabledDays = [],
  highlightedDays = [],
  onDayClick,
  onDayMouseEnter,
  selectedDays = [],
  weekStart = "MON",
  ...props
}) => {
  const monthNr = Number(month);
  const yearNr = Number(year);
  validateDates(yearNr, monthNr);
  const classStyles = cc([styles["co-calendar"], className]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classStyles,
    ref: forwardedRef
  }, props, {
    "data-co-name": "Calendar",
    "data-co-version": "1.1.10",
    "data-co-project": "cobalt"
  }), /*#__PURE__*/React.createElement(WeekDays, {
    days: weekdays,
    weekStart: weekStart
  }), /*#__PURE__*/React.createElement(Days, {
    month: monthNr,
    year: yearNr,
    disabledDays: disabledDays,
    highlightedDays: highlightedDays,
    onDayClick: onDayClick,
    onDayMouseEnter: onDayMouseEnter,
    selectedDays: selectedDays,
    weekStart: weekStart
  }));
};

export default Calendar;
